import { useState } from 'react';

const faqs = [
  {
    q: '今日大瓜的热点内容多久更新一次？',
    a: '我们采用7×24小时不间断追踪机制，热点大瓜和娱乐新闻一旦发生，编辑团队会在第一时间整理发布。日常内容每15-30分钟就有更新，重大娱乐热点事件更是实时跟进，确保你刷到的永远是最新吃瓜资讯。',
  },
  {
    q: '平台上的娱乐爆料内容可靠吗？',
    a: '今日大瓜坚持内容质量优先原则。所有热点爆料都会经过多信源交叉验证后才会发布，对于未经证实的传闻会明确标注"待核实"。我们聚合的信息来源包括主流娱乐媒体、官方社交账号和行业内部渠道，尽可能保障信息的准确性和时效性。',
  },
  {
    q: '如何快速找到我感兴趣的娱乐热点？',
    a: '首页顶部有瓜田索引，按明星、影视、综艺、音乐等分类整理，点击即可跳转。你也可以在导航栏查看实时快讯了解最新动态，或浏览大瓜热榜了解当前最火的话题。所有内容都有清晰的标签分类，方便快速定位。',
  },
  {
    q: '今日大瓜有手机App吗？',
    a: '目前我们提供移动端优化的网页版，你可以在手机浏览器中直接访问，体验流畅丝滑。原生App正在紧锣密鼓开发中，届时将通过页面内的移动端入口公布下载方式，敬请期待。',
  },
  {
    q: '我可以向平台投稿或爆料吗？',
    a: '当然可以！我们非常欢迎热心瓜友提供线索和爆料。你可以通过页面底部的"投稿爆料"区域联系我们的编辑团队。请在投稿时附上尽可能详细的信息和相关证据，我们的编辑会在24小时内进行审核回复。',
  },
  {
    q: '为什么有些热点事件的后续报道看不到了？',
    a: '部分事件可能因涉及隐私保护、法律合规等原因被相关方要求下架或调整。我们始终遵守法律法规，在保障用户知情权的同时，也尊重当事人的合法权益。如有疑问可以通过联系渠道咨询我们的客服团队。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFaq = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section
      id="faq"
      className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100"
      style={{ scrollMarginTop: '80px' }}
    >
      <div className="w-full max-w-3xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            吃瓜答疑
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">
            关于今日大瓜，你想知道的都在这里
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((item, i) => (
            <div
              key={i}
              className="rounded-lg bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => toggleFaq(i)}
                className="w-full flex items-center justify-between gap-3 p-4 md:p-5 text-left cursor-pointer"
              >
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 pr-2">
                  {item.q}
                </h3>
                <span className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${openIndex === i ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
                </span>
              </button>
              {openIndex === i && (
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}